import { render, staticRenderFns } from "./template_edit_dialog.vue?vue&type=template&id=478649a6&scoped=true"
import script from "./template_edit_dialog.vue?vue&type=script&lang=js"
export * from "./template_edit_dialog.vue?vue&type=script&lang=js"
import style0 from "./template_edit_dialog.vue?vue&type=style&index=0&id=478649a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478649a6",
  null
  
)

export default component.exports